/** Генерируется автоматически с помощью EnvconfigPlugin */
import { createEnvVar } from '@alfa-bank/site-envconfig-utils/helpers';

export const ALFAFORM_PIL_FLOW_API = createEnvVar(
    'ALFAFORM_PIL_FLOW_API',
    process.env.ALFAFORM_PIL_FLOW_API
);
export const ANKETA_MAIN_HOST = createEnvVar('ANKETA_MAIN_HOST', process.env.ANKETA_MAIN_HOST);
export const ATM_MAP_URL_FALLBACK = createEnvVar(
    'ATM_MAP_URL_FALLBACK',
    process.env.ATM_MAP_URL_FALLBACK
);
export const AUTH_ALFAID_INITIALIZE = createEnvVar(
    'AUTH_ALFAID_INITIALIZE',
    process.env.AUTH_ALFAID_INITIALIZE
);
export const AUTH_OTP_REQUEST = createEnvVar('AUTH_OTP_REQUEST', process.env.AUTH_OTP_REQUEST);
export const AUTH_OTP_VERIFY = createEnvVar('AUTH_OTP_VERIFY', process.env.AUTH_OTP_VERIFY);
export const AUTH_STATUS = createEnvVar('AUTH_STATUS', process.env.AUTH_STATUS);
export const AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES
);
export const AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS
);
export const AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY
);
export const AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES
);
export const BANANZA_PRIZES = createEnvVar('BANANZA_PRIZES', process.env.BANANZA_PRIZES);
export const BANDIT_URL = createEnvVar('BANDIT_URL', process.env.BANDIT_URL);
export const BASE_API_URL = createEnvVar('BASE_API_URL', process.env.BASE_API_URL);
export const BASE_API_URL_FOR_DEVELOPMENT = createEnvVar(
    'BASE_API_URL_FOR_DEVELOPMENT',
    process.env.BASE_API_URL_FOR_DEVELOPMENT
);
export const CITIES = createEnvVar('CITIES', process.env.CITIES);
export const CITIES_GROUP = createEnvVar('CITIES_GROUP', process.env.CITIES_GROUP);
export const CITIES_GROUP_URL = createEnvVar('CITIES_GROUP_URL', process.env.CITIES_GROUP_URL);
export const CITIES_GROUP_URL_V2 = createEnvVar(
    'CITIES_GROUP_URL_V2',
    process.env.CITIES_GROUP_URL_V2
);
export const CITIES_URL = createEnvVar('CITIES_URL', process.env.CITIES_URL);
export const CITIES_URL_V2 = createEnvVar('CITIES_URL_V2', process.env.CITIES_URL_V2);
export const CITY_BY_IP_URL = createEnvVar('CITY_BY_IP_URL', process.env.CITY_BY_IP_URL);
export const CITY_BY_IP_URL_V2 = createEnvVar('CITY_BY_IP_URL_V2', process.env.CITY_BY_IP_URL_V2);
export const COMMON_DRAFT_ARCHIVARIUS = createEnvVar(
    'COMMON_DRAFT_ARCHIVARIUS',
    process.env.COMMON_DRAFT_ARCHIVARIUS
);
export const CORE_INPUT_ENABLE = createEnvVar('CORE_INPUT_ENABLE', process.env.CORE_INPUT_ENABLE);
export const DADATA_PROXY_CLEAN_ADDRESS = createEnvVar(
    'DADATA_PROXY_CLEAN_ADDRESS',
    process.env.DADATA_PROXY_CLEAN_ADDRESS
);
export const DADATA_PROXY_FIND_BY_PARTY = createEnvVar(
    'DADATA_PROXY_FIND_BY_PARTY',
    process.env.DADATA_PROXY_FIND_BY_PARTY
);
export const DADATA_PROXY_GEOLOCATE_ADDRESS = createEnvVar(
    'DADATA_PROXY_GEOLOCATE_ADDRESS',
    process.env.DADATA_PROXY_GEOLOCATE_ADDRESS
);
export const DADATA_PROXY_SUGGEST_ADDRESS = createEnvVar(
    'DADATA_PROXY_SUGGEST_ADDRESS',
    process.env.DADATA_PROXY_SUGGEST_ADDRESS
);
export const DADATA_PROXY_SUGGEST_FIO = createEnvVar(
    'DADATA_PROXY_SUGGEST_FIO',
    process.env.DADATA_PROXY_SUGGEST_FIO
);
export const DADATA_PROXY_SUGGEST_FMS_UNIT = createEnvVar(
    'DADATA_PROXY_SUGGEST_FMS_UNIT',
    process.env.DADATA_PROXY_SUGGEST_FMS_UNIT
);
export const DADATA_PROXY_SUGGEST_PARTY = createEnvVar(
    'DADATA_PROXY_SUGGEST_PARTY',
    process.env.DADATA_PROXY_SUGGEST_PARTY
);
export const DADATA_SUGGEST_FIO = createEnvVar(
    'DADATA_SUGGEST_FIO',
    process.env.DADATA_SUGGEST_FIO
);
export const DADATA_SUGGEST_PARTY = createEnvVar(
    'DADATA_SUGGEST_PARTY',
    process.env.DADATA_SUGGEST_PARTY
);
export const EMAIL_FIELD = createEnvVar('EMAIL_FIELD', process.env.EMAIL_FIELD);
export const ESIA_GET_AUTH_LINK = createEnvVar(
    'ESIA_GET_AUTH_LINK',
    process.env.ESIA_GET_AUTH_LINK
);
export type TEsiaGetIndividualUuidParams = {
    applicationUuid: string | number;
};
export const ESIA_GET_INDIVIDUAL_UUID = createEnvVar<TEsiaGetIndividualUuidParams>(
    'ESIA_GET_INDIVIDUAL_UUID',
    process.env.ESIA_GET_INDIVIDUAL_UUID
);
export type TEsiaGetUserInfoParams = {
    applicationUuid: string | number;
};
export const ESIA_GET_USER_INFO = createEnvVar<TEsiaGetUserInfoParams>(
    'ESIA_GET_USER_INFO',
    process.env.ESIA_GET_USER_INFO
);
export const FEEDBACK_FORM_HOST = createEnvVar(
    'FEEDBACK_FORM_HOST',
    process.env.FEEDBACK_FORM_HOST
);
export const FONT_PATH_URL = createEnvVar('FONT_PATH_URL', process.env.FONT_PATH_URL);
export const FORMS_CONSUMER_FORMS = createEnvVar(
    'FORMS_CONSUMER_FORMS',
    process.env.FORMS_CONSUMER_FORMS
);
export const GRAPHQL_API_URL = createEnvVar('GRAPHQL_API_URL', process.env.GRAPHQL_API_URL);
export const GRAPHQL_URL_FALLBACK = createEnvVar(
    'GRAPHQL_URL_FALLBACK',
    process.env.GRAPHQL_URL_FALLBACK
);
export const MORTGAGE_API_HOST = createEnvVar('MORTGAGE_API_HOST', process.env.MORTGAGE_API_HOST);
export const MORTGAGE_FORM_HOST = createEnvVar(
    'MORTGAGE_FORM_HOST',
    process.env.MORTGAGE_FORM_HOST
);
export const MORTGAGE_FORM_REGIONS = createEnvVar(
    'MORTGAGE_FORM_REGIONS',
    process.env.MORTGAGE_FORM_REGIONS
);
export const MORTGAGE_SPK_MESSAGE_SEND = createEnvVar(
    'MORTGAGE_SPK_MESSAGE_SEND',
    process.env.MORTGAGE_SPK_MESSAGE_SEND
);
export const OFFERS_CLIENT_URL = createEnvVar('OFFERS_CLIENT_URL', process.env.OFFERS_CLIENT_URL);
export const OFFERS_CODES_URL = createEnvVar('OFFERS_CODES_URL', process.env.OFFERS_CODES_URL);
export const OFFERS_URL = createEnvVar('OFFERS_URL', process.env.OFFERS_URL);
export const OFFICES_MAP_URL_FALLBACK = createEnvVar(
    'OFFICES_MAP_URL_FALLBACK',
    process.env.OFFICES_MAP_URL_FALLBACK
);
export const PROMO_CARDS_ENDPOINT = createEnvVar(
    'PROMO_CARDS_ENDPOINT',
    process.env.PROMO_CARDS_ENDPOINT
);
export const RECAPTCHA_KEY = createEnvVar('RECAPTCHA_KEY', process.env.RECAPTCHA_KEY);
export const RECOGNITION_UTM_URL = createEnvVar(
    'RECOGNITION_UTM_URL',
    process.env.RECOGNITION_UTM_URL
);
export const ROUPER_PERSONALIZATION_URL = createEnvVar(
    'ROUPER_PERSONALIZATION_URL',
    process.env.ROUPER_PERSONALIZATION_URL
);
export type TSearchBlockUrlTemplateParams = {
    text: string | number;
};
export const SEARCH_BLOCK_URL_TEMPLATE = createEnvVar<TSearchBlockUrlTemplateParams>(
    'SEARCH_BLOCK_URL_TEMPLATE',
    process.env.SEARCH_BLOCK_URL_TEMPLATE
);
export const SHERLOCK_SITE_SEARCH = createEnvVar(
    'SHERLOCK_SITE_SEARCH',
    process.env.SHERLOCK_SITE_SEARCH
);
export const STORYBOOK_DADATA = createEnvVar('STORYBOOK_DADATA', process.env.STORYBOOK_DADATA);
export const TRANBILOG_URL = createEnvVar('TRANBILOG_URL', process.env.TRANBILOG_URL);
export type TVimeoIframeTemplateParams = {
    videoId: string | number;
};
export const VIMEO_IFRAME_TEMPLATE = createEnvVar<TVimeoIframeTemplateParams>(
    'VIMEO_IFRAME_TEMPLATE',
    process.env.VIMEO_IFRAME_TEMPLATE
);
export type TVimeoThumbnailTemplateParams = {
    videoId: string | number;
};
export const VIMEO_THUMBNAIL_TEMPLATE = createEnvVar<TVimeoThumbnailTemplateParams>(
    'VIMEO_THUMBNAIL_TEMPLATE',
    process.env.VIMEO_THUMBNAIL_TEMPLATE
);
export type TVkIframeTemplateParams = {
    apiParams: string | number;
    autoplay: string | number;
    hash: string | number;
    ownerId: string | number;
    videoId: string | number;
};
export const VK_IFRAME_TEMPLATE = createEnvVar<TVkIframeTemplateParams>(
    'VK_IFRAME_TEMPLATE',
    process.env.VK_IFRAME_TEMPLATE
);
export const WEB_DEV_KEY = createEnvVar('WEB_DEV_KEY', process.env.WEB_DEV_KEY);
export const YANDEX_METRIC_STATIC_URL = createEnvVar(
    'YANDEX_METRIC_STATIC_URL',
    process.env.YANDEX_METRIC_STATIC_URL
);
export const YANDEX_SEARCH_RESULTS_PAGE_URL = createEnvVar(
    'YANDEX_SEARCH_RESULTS_PAGE_URL',
    process.env.YANDEX_SEARCH_RESULTS_PAGE_URL
);
export const YANDEX_SEARCH_SUGGEST_API_URL = createEnvVar(
    'YANDEX_SEARCH_SUGGEST_API_URL',
    process.env.YANDEX_SEARCH_SUGGEST_API_URL
);
export type TYaMapParams = {
    apiKey: string | number;
};
export const YA_MAP = createEnvVar<TYaMapParams>('YA_MAP', process.env.YA_MAP);
export const YA_MAP_KEY = createEnvVar('YA_MAP_KEY', process.env.YA_MAP_KEY);
export const YA_MAP_SUGGEST_API_KEY = createEnvVar(
    'YA_MAP_SUGGEST_API_KEY',
    process.env.YA_MAP_SUGGEST_API_KEY
);
export type TYoutubeIframeTemplateParams = {
    apiParams: string | number;
    videoId: string | number;
};
export const YOUTUBE_IFRAME_TEMPLATE = createEnvVar<TYoutubeIframeTemplateParams>(
    'YOUTUBE_IFRAME_TEMPLATE',
    process.env.YOUTUBE_IFRAME_TEMPLATE
);
export type TYoutubeThumbnailTemplateParams = {
    videoId: string | number;
};
export const YOUTUBE_THUMBNAIL_TEMPLATE = createEnvVar<TYoutubeThumbnailTemplateParams>(
    'YOUTUBE_THUMBNAIL_TEMPLATE',
    process.env.YOUTUBE_THUMBNAIL_TEMPLATE
);
